import React from 'react';
import '../../styles/pages.css';

const PrivacyPolicyPage = () => {
  return (
    <div className="static-page">
      <h2 className="page-title">Política de Privacidade</h2>

      <p className="last-updated"><strong>Última atualização:</strong> 24 de novembro de 2025</p>

      <p>A sua privacidade é importante para nós. É política da <strong>Gabrielly Semijoias</strong> respeitar a sua privacidade em relação a qualquer informação sua que possamos coletar no site <a href="https://gabriellysemijoias.com">https://gabriellysemijoias.com</a> e outros sites que possuímos e operamos.</p>

      <section>
        <h3>1. Informações que Coletamos</h3>
        <p>Solicitamos informações pessoais apenas quando realmente precisamos delas para lhe fornecer um serviço. Fazemo-lo por meios justos e legais, com o seu conhecimento e consentimento. Também informamos por que estamos coletando e como será usado.</p>
        <ul>
          <li><strong>Informações de Cadastro:</strong> Nome completo, e-mail, CPF, número de telefone e endereço, que são necessários para processar seus pedidos e garantir a entrega.</li>
          <li><strong>Informações de Pagamento:</strong> Trabalhamos com gateways de pagamento seguros (como Mercado Pago) e não armazenamos os detalhes do seu cartão de crédito em nossos servidores. As informações fornecidas são criptografadas e enviadas diretamente para a instituição financeira.</li>
          <li><strong>Informações de Navegação:</strong> Podemos coletar dados como endereço IP, localização, tipo de navegador, páginas visitadas e tempo de permanência para melhorar sua experiência em nosso site.</li>
        </ul>
      </section>

      <section>
        <h3>2. Como Usamos as Informações</h3>
        <p>Utilizamos as informações coletadas para:</p>
        <ul>
          <li>Processar, faturar e enviar seus pedidos.</li>
          <li>Comunicar-nos com você sobre o status do seu pedido, ofertas e promoções (caso você opte por recebê-las).</li>
          <li>Personalizar sua experiência de navegação.</li>
          <li>Melhorar nossos produtos, serviços e a funcionalidade do site.</li>
          <li>Cumprir obrigações legais e fiscais.</li>
        </ul>
      </section>

      <section>
        <h3>3. Compartilhamento de Informações</h3>
        <p>Não compartilhamos suas informações de identificação pessoal publicamente ou com terceiros, exceto quando exigido por lei ou para viabilizar a operação dos nossos serviços (por exemplo, com empresas de transporte para entrega dos produtos e com plataformas de pagamento para processar a compra). Exigimos que esses parceiros cumpram rigorosos padrões de privacidade e segurança.</p>
      </section>

      <section>
        <h3>4. Segurança dos Dados</h3>
        <p>Protegemos suas informações com medidas de segurança comercialmente aceitáveis para prevenir perdas e roubos, bem como acesso, divulgação, cópia, uso ou modificação não autorizados. Nosso site utiliza certificado SSL (Secure Socket Layer) que garante que a comunicação entre seu navegador e nossos servidores seja criptografada e segura.</p>
      </section>

      <section>
        <h3>5. Seus Direitos</h3>
        <p>Você tem o direito de acessar, corrigir ou excluir suas informações pessoais a qualquer momento. Você pode fazer isso através da sua página de "Minha Conta" ou entrando em contato conosco. Você também é livre para recusar a nossa solicitação de informações pessoais, entendendo que talvez não possamos fornecer alguns dos serviços desejados.</p>
      </section>

      <section>
        <h3>6. Cookies</h3>
        <p>Utilizamos cookies para melhorar a sua experiência de compra. Cookies são pequenos arquivos de dados que nos permitem lembrar de suas preferências e dos itens no seu carrinho de compras. Você pode desativá-los nas configurações do seu navegador, mas isso pode afetar a funcionalidade do site.</p>
      </section>

      <section>
        <h3>7. Alterações nesta Política</h3>
        <p>Podemos atualizar nossa política de privacidade de tempos em tempos. Recomendamos que você revise esta página periodicamente para quaisquer alterações.</p>
      </section>

      <section>
        <h3>8. Contato</h3>
        <p>Se você tiver alguma dúvida sobre como lidamos com os dados do usuário e informações pessoais, entre em contato conosco através do e-mail: <strong>contato@gabriellysemijoias.com</strong>.</p>
      </section>
    </div>
  );
};

export default PrivacyPolicyPage;
